const baseUrl = '/vendors';
export const vendorsRoutes = {
  baseUrl: "".concat(baseUrl),
  association: "".concat(baseUrl, "/association"),
  utilityProviderId: utilityProviderId => "".concat(baseUrl, "/").concat(utilityProviderId)
};